
// IE���� ActiveX ��뿩��
// true : ActiveX �ε� ���� object tag���� �߰�
// false : Cookie ��� ���� ���� nsdPlugin_NA.js ��ũ��Ʈ �߰�
var usingActiveX = false; 

// jquery�� �̿��� JS ������ �ε� �ϸ�
// �÷����� �ռ��� ��� ����� �� �ֽ��ϴ�.
var bJquery = true;
try{
if($)
{
	//alert('jqeury!!!');
	bJquery = true;
} 
}
catch(e){
}

function loadfile(filename, filetype){
	var fileref = null;
    if (filetype=="js"){ //if filename is a external JavaScript file
        fileref=document.createElement('script');
        fileref.setAttribute("type","text/javascript");
        fileref.setAttribute("src", filename);
    }
    else if (filetype=="css"){ //if filename is an external CSS file
        fileref=document.createElement("link");
        fileref.setAttribute("rel", "stylesheet");
        fileref.setAttribute("type", "text/css");
        fileref.setAttribute("href", filename);
    }
    else if (filetype=="obj"){ //Load Object
		//<object id="nsd" classid="clsid:149D3194-E118-47D9-9737-D17D2A44683F" codebase="nsd.cab#Version=1,0,0,21" width="0" height="0"></object>
		fileref=document.createElement("object");
        fileref.setAttribute("id", "nsd");
        fileref.setAttribute("classid", "clsid:149D3194-E118-47D9-9737-D17D2A44683F");
        fileref.setAttribute("codebase", filename);
    }
    if (fileref!=null)
    {
		document.getElementsByTagName("head")[0].appendChild(fileref);
	}
}

function loadPlugin()
{
	var userAgent = navigator.userAgent.toLowerCase();
	var appName = navigator.appName.toLowerCase();
	if(userAgent.indexOf('chrome')> 0)
	{
		// Chrome - userAgent: "Mozilla/5.0 (Windows NT 6.1) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/48.0.2564.116 Safari/537.36"
		if(bJquery)
		{
			$('head').append('<script src=\'/static/js/nsd/nsdPlugin_CH.js\'><\/script>');
		}
		else
		{
//			alert('3');
			loadfile("/static/js/nsd/nsdPlugin_CH.js", "js");
		}
	}
	else if(userAgent.indexOf("msie") != -1 || appName.indexOf("microsoft internet explorer") != -1 || appName.indexOf("netscape") != -1 ) 
	{
//		alert('22');
		// IE 11 - "Mozilla/5.0 (Windows NT 6.1; Trident/7.0; SLCC2; .NET CLR 2.0.50727; .NET CLR 3.5.30729; .NET CLR 3.0.30729; Media Center PC 6.0; MS-RTC LM 8; .NET4.0C; .NET4.0E; InfoPath.3; Tablet PC 2.0; rv:11.0) like Gecko"
		if(bJquery)
		{
			if(usingActiveX)
				$('head').append('<object id="nsd" classid="clsid:149D3194-E118-47D9-9737-D17D2A44683F" codebase="/static/js/nsd/nsd.cab#Version=1,0,0,26" width="0" height="0"></object>');
			else
				$('head').append('<script src=\'/static/js/nsd/nsdPlugin_NA.js\'><\/script');			

			$('head').append('<script src=\'/static/js/nsd/nsdPlugin_IE.js\'><\/script>');

		}
		else
		{
			if(usingActiveX)
				loadfile("/static/js/nsd/nsd.cab#Version=1,0,0,26", "obj");
			else
				loadfile("/static/js/nsd/nsdPlugin_NA.js", "js");
				
			loadfile("/static/js/nsd/nsdPlugin_IE.js", "js");
		}

	}
	else
	{
		alert("Unknown Browser!!");
	}
}

var nsdPlugin = loadPlugin();

export {nsdPlugin};



//////////////////
// WEBPACK FOOTER
// ./static/js/nsd/nsdPlugin.js
// module id = oumx
// module chunks = 0